import React from "react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { SolicitudDetalle } from "../../dtos/Envase";
import "./AccionPopup.css";

interface AccionPopupProps {
  visible: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  detalle: SolicitudDetalle | null;
  action: "baja" | "edicion" | null;
}

const AccionPopup: React.FC<AccionPopupProps> = ({
  visible,
  loading,
  onClose,
  onConfirm,
  detalle,
  action,
}) => {
  const isBaja = action === "baja";
  const titleText = isBaja
    ? "Confirmar Baja de Envase"
    : "Revisar Solicitud de Edición";
  const confirmText = isBaja ? "Confirmar Baja" : "Confirmar Edición";
  const confirmButtonType = isBaja ? "danger" : "success";

  const V = (v: unknown) =>
    v === null || v === undefined || v === "" ? "—" : String(v);

  const renderContent = () => {
    if (loading) {
      return (
        <div className="popup-loading">
          <LoadIndicator height={40} width={40} />
        </div>
      );
    }
    if (!detalle) {
      return (
        <div className="popup-error">
          No se pudieron cargar los detalles de la solicitud.
        </div>
      );
    }

    return (
      <div className="popup-scroll">
        <div className="card">
          <dl className="kv-grid">
            <div className="kv-item">
              <dt className="kv-label">Número de Serie</dt>
              <dd className="kv-value">{V(detalle.numeroSerie)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Código Producto</dt>
              <dd className="kv-value">{V(detalle.codigoProducto)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Peso Tara</dt>
              <dd className="kv-value">
                {detalle.pesoTara != null ? `${detalle.pesoTara} kg` : "—"}
              </dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Fabricante</dt>
              <dd className="kv-value">{V(detalle.fabricante)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Modelo</dt>
              <dd className="kv-value">{V(detalle.modelo)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Tipo Envase</dt>
              <dd className="kv-value">{V(detalle.tipoDeEnvase ?? detalle.idTipoEnvase)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Cuerpo</dt>
              <dd className="kv-value">{V(detalle.codigoCuerpo)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Capuchón</dt>
              <dd className="kv-value">{V(detalle.codigoCapuchon)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Cuello</dt>
              <dd className="kv-value">{V(detalle.codigoCuello)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Estarcido</dt>
              <dd className="kv-value">{V(detalle.codigoEstarcido)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Ojiva</dt>
              <dd className="kv-value">{V(detalle.codigoOjiva)}</dd>
            </div>
            <div className="kv-item">
              <dt className="kv-label">Válvula</dt>
              <dd className="kv-value">{V(detalle.valvula ?? detalle.idValvula)}</dd>
            </div>
          </dl>
        </div>

        <div className="card">
          <div className="section-title">Motivo de la Solicitud</div>
          {detalle.motivo ? (
            <p className="motivo-text">{detalle.motivo}</p>
          ) : (
            <div className="empty-evidence">No se especificó un motivo.</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      dragEnabled={false}
      closeOnOutsideClick
      showTitle
      titleRender={() => (
        <div className="custom-popup-title">
          <span className="title-dot" />
          {titleText}
        </div>
      )}
      width="92vw"
      maxWidth={720}
      minWidth={320}
      height="auto"
      maxHeight="82vh"
      shading
      showCloseButton
    >
      {renderContent()}
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          text: confirmText,
          type: confirmButtonType,
          stylingMode: "contained",
          onClick: onConfirm,
          disabled: loading,
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          text: "Cancelar",
          stylingMode: "text",
          onClick: onClose,
          disabled: loading,
        }}
      />
    </Popup>
  );
};

export default AccionPopup;
